import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  approvedAgentTgBot,
  createAgent,
  updateAgentUrl,
} from "../../../services/api/instances/agentsApi/api";
import { AgentValue } from "../../../services/api/instances/agentsApi/types";
import { RootState } from "../../../services/redux/types";
import { setAgentValue } from "./slice";
import { addStorageObject } from "../../../app/state/storageObjectSlice/actions/actions";
import { generateId } from "../../../shared/utils/generateId";
import { getError } from "../../../services/lib/getError";

export const createAgentAction = createAsyncThunk(
  "agent/createAgent",
  async (
    { objectName, agentName }: { objectName: string; agentName: string },
    { dispatch, rejectWithValue },
  ) => {
    try {
      const agentUid = generateId();

      const response = await createAgent({
        agent_uid: agentUid,
        agent_name: agentName,
        config_name: "default",
      });

      const initialValue: AgentValue = {
        agent_object: {
          uid: agentUid,
          iframe_src: response.iframe_src,
          agent_name: agentName,
        },
      };

      dispatch(setAgentValue(initialValue));
      const object = await dispatch(
        addStorageObject({
          name: objectName,
          service: "krab",
          objectType: "child",
          value: initialValue,
        }),
      ).unwrap();
      return object;
    } catch (e: unknown) {
      const message = getError(e);
      return rejectWithValue(message ?? "An unknown error occurred");
    }
  },
);

export const updateAgentUrlAction = createAsyncThunk(
  "agent/updateAgentUrl",
  async (uid: string, { getState, rejectWithValue }) => {
    try {
      const { agentValue } = (getState() as RootState).agentState;
      const response = await updateAgentUrl(uid);
      return response;
    } catch (e: unknown) {
      const message = getError(e);
      return rejectWithValue(message ?? "An unknown error occurred");
    }
  },
);

export const approvedAgentTgBotAction = createAsyncThunk(
  "agent/approvedAgentTgBot",
  async (
    { uid, token }: { uid: string; token: string },
    { rejectWithValue },
  ) => {
    try {
      return await approvedAgentTgBot(uid, { code: token });
    } catch (e: unknown) {
      const message = getError(e);
      return rejectWithValue(message ?? "An unknown error occurred");
    }
  },
);
